import { History } from "history";
import { BehaviorSubject, Observable } from "rxjs";
import { combinePath }  from "keautils";

let history: History;

/**Ruta actual */
const pathSubject = new BehaviorSubject<string>("/");
/**Observable de la ruta actual */
export const pathRx: Observable<string> = pathSubject;
/**Devuelve un observable que indica si la aplicacion se encuentra en la ruta base o en alguna ruta mas anidada. Es util para colorear los menus de la ruta que esta seleccionada */
export function enRuta(basePath: string): Observable<boolean> {
    return pathRx.map(x => x.startsWith(basePath));
}

/**Al iniciar la aplicación, establece el manejador de la historia de las URLs */
export function setHistory(value: History) {
    if (history != null) throw new Error("Solo se puede llamara a setHistory una vez en toda la aplicación");
    history = value;

    history.listen(x => {
        pathSubject.next(x.pathname);
    });
}


/**Viaja a una dirección */
export function go(path: string) {
    history.push(combinePath(history.location.pathname, path));
}

export function goExtRoute( path: string ){
    window.open(path);
}

export function goBack() {
    history.goBack();
}


// WEBPACK FOOTER //
// ./app/main/history.ts